import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['popoverContent', 'userName', 'shiftCoverUserId', 'shift2Id']

  showPopover(event) {
    event.stopImmediatePropagation()

    let content = this.popoverContentTarget.innerHTML
    // workaround to render tomselect when popover is shown, not earlier
    content = content.replace(/DATA_CONTROLLER/g, 'tomselect')

    const container = `#${this.element.getAttribute('id')}`
    const button = event.target

    this.pop = new bootstrap.Popover(button, {
      content: content,
      container: container,
      title: 'Select Employee for Shift cover',
      html: true,
      sanitize: false,
      customClass: 'shift-swap-shift-cover-container min-width-300px'
    })

    this.pop.show()
  }

  userSelectedCallback(event) {
    this.userNameTarget.textContent = event.detail.userName
    this.shiftCoverUserIdTarget.value = event.detail.userId

    this.shiftCoverUserIdTarget.disabled = false
    //TODO: set to true on other side

    this.shift2IdTarget.disabled = true
    //TODO: set true when turn off shift cover or rather show hide when shiftCover value changed (add)

    //const date_input = this.element.querySelector(`input[name = 'shift${event.detail.shiftIndex}_date']`)
    this.pop.hide()
  }

  hidePopover(event) {
    event.preventDefault()
    this.pop.hide()
  }
}
